import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { NgxPendoService } from 'ngx-pendo';

import { AppConfig } from '®shared/config';

import { CurrentUserAndPermissions } from '../current-user';

@Injectable()
export class PendoService {
  constructor(
    private appConfig: AppConfig,
    private ngxPendoService: NgxPendoService,
  ) {}

  /**
   * Proxy through to NgxPendoService's initialize()
   */
  public initialize(user: CurrentUserAndPermissions): void {
    if (!user.hasTarlAccount) {
      return;
    }
    const tenantCode = this.appConfig.tenant.shortCode;

    // Only use Pendo for broadminster and cst tenancies during the trial period.
    // We are current sending user name but this is only as opened up for internal
    // tenancies whilst reviewing GDPR implications. ('testone' allowed for our own testing)
    if (List(['testone', 'broadminster', 'cst']).includes(tenantCode)) {
      const userData = {
        id: user.oauthUser.guid,
        name: user.oauthUser.fullName,
      };

      const accountData = {
        id: tenantCode,
      };

      this.ngxPendoService.initialize(userData, accountData);
    }
  }
}
